import React from "react";
import { Box, Flex, Spacer, Text } from "@chakra-ui/react";

export type AstroRowProps = {
  label: string;
  value: string;
  icon: React.ReactNode;
};

const AstroRow: React.FC<AstroRowProps> = ({ label, value, icon }) => {
  return (
    <Flex align="center" gap={3} py={{ base: 2, md: 3 }}>
      <Box color="#E35E00">{icon}</Box>
      <Flex w="full" align="center">
        <Box>
          <Text fontSize={{ base: "14px", md: "13px" }} fontWeight="800" letterSpacing="0.12em" color="#8a7b7b" textTransform="uppercase">
            {label}
          </Text>
          <Text fontSize={{ base: "12px", md: "14px" }} fontWeight="800" color="#E35E00">
            {value}
          </Text>
        </Box>
        <Spacer />
      </Flex>
    </Flex>
  );
};

export default AstroRow;
